export enum ProcessStates {
  Opened = 'OPENED',
  // Closed = 'CLOSED',
  Rejected = 'REJECTED',
  Completed = 'COMPLETED',
  CANCELED ='ANULADO',
  DESISTED ='DESISTIDO',
  SUSPENDED = 'SUSPENDED'
}